import { render } from "./cadastro_revisao.vue?vue&type=template&id=3297e45c&scoped=true"
import script from "./cadastro_revisao.vue?vue&type=script&lang=js"
export * from "./cadastro_revisao.vue?vue&type=script&lang=js"

import "./cadastro_revisao.vue?vue&type=style&index=0&id=3297e45c&scoped=true&lang=css"

import exportComponent from "D:\\DealDesk\\Homologação\\Mult_Cliente\\front_mult_clint\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3297e45c"]])

export default __exports__